import React from 'react';
import { StudentChecklistValue } from './types';
import moment from 'moment/moment';
import { getDateFormat } from '../../../../utils/date';
import { CellContext } from '@tanstack/react-table';

const ChecklistValueCell = (info: CellContext<any, StudentChecklistValue>) => {
	const checklistValue = info.cell.getValue();
	if (!checklistValue.value) {
		return null;
	}

	if (checklistValue.value.checked !== undefined) {
		return checklistValue.value.checked ? (
			<span className="glyphicons glyphicons-square-check text-success pe-1" />
		) : null;
	}

	if (checklistValue.value.examDate === undefined) {
		return null;
	}

	const formattedExamDate = getDateFormat(checklistValue.value.examDate);
	if (moment(checklistValue.value.examDate).isAfter(moment())) {
		// Item planned in future: show calendar icon
		return (
			<>
				<span className="glyphicons glyphicons-calendar text-success pe-1" />
				<span>{formattedExamDate}</span>
			</>
		);
	}
	if (checklistValue.value.examResult !== null) {
		return checklistValue.value.examResult ? (
			<>
				<span className="glyphicons glyphicons-square-check text-success pe-1" />
				<span>{formattedExamDate}</span>
			</> // Student passed exam
		) : (
			<>
				<span className="glyphicons glyphicons-square-remove text-danger pe-1" />
				<span>{formattedExamDate}</span>
			</>
		); // Student failed exam
	}
	return null;
};

export default ChecklistValueCell;
